module.exports = __webpack_public_path__ + "img/Trello.f3529ba6.png";